<template>
  <div v-if="showPreview" class="preview">
    <div class="post-entry">
      <div>
        <b-form-input id="range-1" v-model="fontSizePostTitle" type="range" step="0.1" min="1" max="10"></b-form-input>
        <div class="post-entry-title">
          <p :style="`font-size: ${fontSizePostTitle}rem`">
            {{ postTitle }}
          </p>
        </div>
        <b-form-input class="mt-3" id="range-1" v-model="fontSizePostContent" type="range" step="0.1" min="1"
          max="10"></b-form-input>
        <div class="post-entry-content" :style="`font-size: ${fontSizePostContent}rem`"
          v-html="postContent.replace(/^\n+|\n+$/g, '').replace(/\n/g, '<br>')">
        </div>
      </div>
      <div class=" d-flex justify-content-center" ref="DateContainer">
        <b-button @click="closePreview" variant="primary">Vorschau schließen</b-button>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="user" class="container w-100 d-flex flex-column">
      <div class="d-flex flex-column mb-5 mt-5 justify-content-center w-100">
        <div v-if="postsDataArray === undefined">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-if="message.success !== undefined" class="messages-banner">
          <div class="alert alert-success fixed-top text-center message-banner" role="alert">
            {{ message.success }}
          </div>
        </div>
        <div v-if="message.error !== undefined" class="messages-banner">
          <div class="alert alert-error fixed-top text-center message-banner" role="alert">
            {{ message.error }}
          </div>
        </div>
        <div id="InputField" tabindex="-1" class="d-flex w-100 mt-3 mb-4 ">
          <h1>Beträge anlegen</h1>
        </div>
        <div v-if="editEnabled">
          <b-alert show variant="warning">Der Beitrag ist nun editierbar und kann anschließend gespeichert
            werden.</b-alert>
        </div>
        <b-alert v-if="showWarning" show variant="danger">Füllen Sie die Felder korrekt
          aus.</b-alert>
        <b-alert v-if="showWarningChanges" show variant="danger">Füllen Sie die Felder korrekt
          aus.</b-alert>
        <div class="w-100">
          <div>
            <p class="pb-3">Beitrag Überschrift</p>
            <b-form-input v-model="postTitle" placeholder="Beitrag Überschrift eingeben..."></b-form-input>
          </div>
          <div class="mt-3">
            <p class="pb-3">Beitrag Inhalt</p>
            <b-form-textarea id="textarea" v-model="postContent" placeholder="Beitrag Inhalt eingeben..." rows="9"
              max-rows="12"></b-form-textarea>
          </div>
          <div class="w-100 d-flex justify-content-end mt-4">
            <b-button :disabled="!fieldIsFilled" class="mr-3" @click="preview"
              variant="outline-secondary">Vorschau</b-button>
            <b-button class="mr-3" @click="cancel" variant="outline-danger">Abbrechen</b-button>
            <b-button v-if="editEnabled" @click="saveChanges" variant="outline-primary">Änderungen Speichern</b-button>
            <b-button v-else @click="save" variant="outline-primary">Speichern</b-button>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <h3>Aktueller Beträge</h3>
        <div class="post mt-4 w-100 " v-for="item in postsDataArray" :key="item.id">
          <div class="post-content d-flex justify-content-between w-100">
            <div class="d-flex w-75">
              <p class="w-25 mr-5 one-line-ellipsis-title">{{ item.postTitle }}</p>
              <p class="w-50 one-line-ellipsis">{{ item.postContent }}</p>
            </div>
            <div class="d-flex w-25 justify-content-end">
              <b-button size="sm" class="mr-3" @click="enableEdit(item)" variant="outline-primary">Bearbeiten</b-button>
              <b-button size="sm" @click="deletePost(item.id)" variant="outline-danger">Löschen</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { ref, getDatabase, set, onValue, remove, update } from "firebase/database";
import "moment-timezone/builds/moment-timezone-with-data-1970-2030";
import moment from "moment-timezone";
import { nextTick } from "vue";

export default {
  computed: {
    fieldIsFilled() {
      return this.postContent && this.postTitle
    },
    ...mapGetters({
      user: "user",
    }),
  },
  data() {
    return {
      postsDataArray: [],
      message: {
        success: undefined,
        error: undefined,
      },
      postTitle: null,
      postContent: null,
      tempPostId: null,
      showWarning: false,
      showWarningChanges: false,
      editEnabled: false,
      showPreview: false,
      fontSizePostTitle: "3.5",
      fontSizePostContent: "3",
      created: moment(new Date()).locale('de').format('ll') + ', ' + moment(new Date()).locale('de').format('LT'),
    };
  },
  methods: {
    closePreview() {
      this.showPreview = false;
    },
    preview() {
      this.showPreview = true;
      nextTick(() => {
        this.$refs.DateContainer?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    async save() {
      if (this.postTitle !== null && this.postContent !== null
      ) {
        const id = self.crypto.randomUUID();
        this.showWarning = false;
        try {
          await set(ref(getDatabase(), 'posts/' + id), {
            id: id,
            postTitle: this.postTitle,
            postContent: this.postContent,
            created: this.created,
            fontSize: {
              title: this.fontSizePostTitle,
              content: this.fontSizePostContent
            }
          });
          this.message.success = "Die Daten wurden erfolgreich gespeichert und werden in ungefähr zwei Minuten aktualisiert.";
          setTimeout(this.resetMessage, 3000);
          this.postTitle = null;
          this.postContent = null
          return;
        } catch (err) {
          this.message.error = "Es ist ein Fehler aufgetreten.<br>" + err;
          setTimeout(this.resetMessage, 3000);
          return;
        }
      } else {
        this.showWarning = true;
      }
    },

    async saveChanges() {
      if (this.postTitle !== "" && this.postContent !== "") {
        this.showWarningChanges = false;
        try {
          update(ref(getDatabase(), 'posts/' + this.tempPostId), {
            id: this.tempPostId,
            postTitle: this.postTitle,
            postContent: this.postContent,
            created: this.created,
            fontSize: {
              title: this.fontSizePostTitle,
              content: this.fontSizePostContent
            }
          })
          this.tempPostId = null;
          this.postTitle = null;
          this.postContent = null;
          this.editEnabled = false
          this.message.success = "Die Daten wurden erfolgreich aktualisiert.";
          setTimeout(this.resetMessage, 3000);
          return
        } catch (err) {
          this.message.error = "Es ist ein Fehler aufgetreten.<br>" + err;
          setTimeout(this.resetMessage, 3000);
          return;
        }

      } else {
        console.log("this.showWarning = true")
        this.showWarningChanges = true
      }
    },
    cancel() {
      this.tempPostId = null;
      this.postTitle = null;
      this.postContent = null;
      this.editEnabled = false;
      this.showWarning = false;
      this.showWarningChanges = false;
    },
    enableEdit(item) {
      this.editEnabled = true;
      this.ShowWarning = false;
      this.tempPostId = item.id;
      this.postTitle = item.postTitle;
      this.postContent = item.postContent;
      this.fontSizePostTitle = item.fontSize.title;
      this.fontSizePostContent = item.fontSize.content;
      document.getElementById("InputField").focus();
    },
    deletePost(id) {
      remove(ref(getDatabase(), 'posts/' + id))
    },
    resetMessage() {
      this.message.success = undefined;
      this.message.error = undefined;
    },
    loadPostsData() {
      onValue(ref(getDatabase(), `/posts`), (snapshot) => {
        this.postsDataArray = snapshot.val();
        return null;
      });
    },

  },
  beforeMount() {
    this.loadPostsData();
  },
};
</script>
<style scoped>
p {
  font-size: larger;
}

.post {
  margin: 1rem 0;
  padding: 1rem;
  background-color: rgba(226, 224, 224, 0.443);
  box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;
  border-radius: 8px;
}


.one-line-ellipsis-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.one-line-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

p {
  padding: 0;
  margin: 0;
}

.message-banner {
  margin-top: 60px;
}

.expand {
  border: none;
  color: #90979e;
  height: 38px;
  font-size: 38px;
  padding: none;
  overflow: clip;
  align-self: center;
  position: relative;
  left: 936px;
}

.expand span {
  bottom: 19px;
  position: relative;
}

.expand:hover {
  color: #222f3ecb;
}

.topBorder {
  border-top: 1px solid rgb(196, 196, 196);
}

.preview {
  background-color: #252525;
  inset: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
}

.post-entry {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 2rem 2rem 0 2rem;
}

.post-entry-title {
  text-align: center;
  width: 100%;
  background-color: #303030;
  border-radius: 16px;
  padding: 1rem;
}

.post-entry-title>p {
  font-weight: 700;
  color: white;
  overflow: hidden;
  hyphens: auto;
  word-break: break-word;
}

.post-entry-content {
  display: flex;
  justify-content: left;
  background-color: #303030;
  border-radius: 16px;
  padding: 0 4rem 0 4rem;
  margin-top: 0;
  width: 100%;
  font-weight: 600;
  color: white;
  margin: 0;
  overflow: hidden;
  hyphens: auto;
  word-break: break-word;
}
</style>
